module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"echo-echo\"-in-inglewood-california-cca434abb817c455417cecd0df26fb8a.png";